import React, { createContext, useState, useEffect, useContext } from 'react';
import { useAppContext } from './Context';

const TranslationContext = createContext({
	language: 'en',
	setLanguage: () => {},
	t: (key, params) => key,
	translationButtons: []
});

export const TranslationProvider = ({ children }) => {
	const { psServer } = useAppContext();
	const [language, setLanguage] = useState('en');
	const [allTranslations, setAllTranslations] = useState({});
	const [translationButtons, setTranslationButtons] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchAllTranslations = async () => {
		setLoading(true);
		setError(null);
		try {
			const response = await fetch(`${psServer}/ui/languages`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				}
			});
			if (!response.ok) {
				throw new Error('Failed to fetch translations');
			}
			const data = await response.json();
			const processedButtons = [];
			const processedTranslations = {};
			data.forEach(item => {
				try {
					processedButtons.push({
						langCode: item.langCode,
						lang: item.lang,
						icon: item.icon,
					});
					processedTranslations[item.langCode] = JSON.parse(item.jsonString);
				} catch (parseError) {
					console.error(`Error parsing JSON for ${item.langCode}:`, parseError);
				}
			});
			setAllTranslations(processedTranslations);
			setTranslationButtons(processedButtons);
		} catch (err) {
			setError(err);
		} finally {
			setLoading(false);
		}
	};

	fetchAllTranslations();
	}, []);

	const t = (key, params = {}) => {
		if (loading) return 'Loading...';
		if (error) return `Error: ${error.message}`;

		const languageTranslations = allTranslations[language] || {};
		let translation = languageTranslations[key] || key;
		Object.keys(params).forEach((param) => {
			translation = translation.replace(`{{${param}}}`, params[param]);
		});
		return translation;
	};

	return (
		<TranslationContext.Provider
			value={{ language, setLanguage, t, translationButtons, loading, error }}
		>
			{children}
		</TranslationContext.Provider>
	);
};

export const useTranslation = () => useContext(TranslationContext);